import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X } from "lucide-react";
import { api } from "@/lib/api";
import { StageBadge } from "@/components/Badges";
import { SERVICES } from "@/lib/constants";

export const GlobalSearch = () => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const nav = useNavigate();
  const box = useRef(null);

  useEffect(() => {
    if (q.trim().length < 2) return setRes(null);
    const t = setTimeout(() => api.get("/leads", { params: { q, limit: 8 } }).then((r) => setRes(r.data)).catch(() => setRes([])), 300);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    const h = (e) => box.current && !box.current.contains(e.target) && setRes(null);
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const go = (id) => { setQ(""); setRes(null); nav(`/leads/${id}`); };

  return (
    <div ref={box} className="relative w-full">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-400" />
      <input data-testid="global-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, phone, company, service…"
        className="h-10 w-full rounded-lg border border-neutral-200 bg-white pl-9 pr-9 text-sm text-[#1A1A1A] placeholder:text-neutral-400 focus:border-[#1F9E7A] focus:outline-none" />
      {q && <button data-testid="global-search-clear" onClick={() => setQ("")} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-neutral-400"><X className="h-4 w-4" /></button>}
      {res && (
        <div data-testid="global-search-results" className="absolute z-50 mt-2 w-full overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-2xl">
          {res.length === 0 && <p className="p-4 text-sm text-neutral-500">No matching leads</p>}
          {res.map((l) => (
            <button key={l.id} data-testid={`search-result-${l.id}`} onClick={() => go(l.id)} className="flex w-full items-center justify-between gap-3 border-b border-neutral-200/70 px-4 py-3 text-left hover:bg-neutral-100/50">
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-[#1A1A1A]">{l.full_name} <span className="text-neutral-400">· {l.company_name || "—"}</span></p>
                <p className="font-mono text-xs text-neutral-400">{l.phone_e164} · {SERVICES[l.service_category]}</p>
              </div>
              <StageBadge stage={l.lifecycle_stage} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
